/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  AutoComplete,
  Button,
  Col,
  Divider,
  Dropdown,
  Input,
  // Popover,
  Row,
  Select,
  Modal,
  DatePicker,
  Table,
  Tooltip,
  Badge,
  // Image,
  Typography,
  Skeleton,
} from "antd";
import {
  FileTextOutlined,
  DownOutlined,
  PlusOutlined,
  DeleteOutlined,
  // ArrowDownOutlined,
  // ArrowUpOutlined,
  EditOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import "./index.css";
import { items } from "./data";
import { Prompt, useHistory } from "react-router";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import useBeforeUnload from "../../components/Prompting";
import {
  loadExpensesList,
  loadExpensesCategories,
} from "../../store/expenses/actions";

import { useDispatch, useSelector } from "react-redux";
// import SimpleReactValidator from "simple-react-validator";
import { toast, ToastContainer } from "react-toastify";
import useMedia from "use-media-antd-query";
import api from "../../helpers";
import moment from "moment";
import { BiCalendar } from "react-icons/bi";

const Expenses = (props) => {
  const { RangePicker } = DatePicker;

  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [dateFilter, setDateFilter] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const media = useMedia();

  //validator
  // const simpleValidator = useRef(new SimpleReactValidator());
  // const [, forceUpdate] = useState();

  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoDetails = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  const organizationId = !isEmpty(userInfoDetails) && userInfoDetails;

  const orgList = { organizationId: organizationId };

  //api loader
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setLoading(false);
      setTableLoading(false);
    }, 2000);
    dispatch(loadExpensesList(orgList));
    dispatch(loadExpensesCategories(orgList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { expenses_list = [], expenses_categories_list = [] } = useSelector(
    (state) => state.Expenses
  );

  // const { expenses_categories_list = [] } = useSelector((state) => state.Items);

  const [pageRouting, setPageRouting] = useState(false);

  // category
  const [categories, setCategories] = useState([]);
  const [selectDays, setSelectDays] = useState([]);
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [newExpenseCategory, setNewExpenseCategory] = useState(false);
  const [deleteCategory, setDeleteCategory] = useState(false);
  const [newExpenseMode, setNewExpenseMode] = useState("");
  const [expenseData, setExpenseData] = useState({
    expenseName: "",
    _id: "",
  });

  const handleChange = (e) => {
    setExpenseData({
      ...expenseData,
      [e.target.name]: e.target.value,
    });
  };
  const categoryOptions =
    expenses_categories_list.length > 0
      ? expenses_categories_list.map((c) => {
          return {
            label: c.expenseName,
            value: c._id,
          };
        })
      : [];

  //expense routes
  const expenseRoutes = (data) => {
    history.push({
      pathname: "/expenses/data",
      state: {
        organizationId: organizationId,
        userId: userId,
        orgList: orgList,
        categoryOptions: categoryOptions,
        data: data,
      },
    });
  };

  //header columns
  const HeaderData = [
    {
      key: "expenseDate",
      title: <p className="header-purchase-invoice font-semibold">Date</p>,
      sorter: (a, b) => a.expenseDate.length - b.expenseDate.length,
      dataIndex: "expenseDate",
      render: (record, text, row) => (
        <p
          onClick={() => expenseRoutes(text)}
          className="header-purchase-invoice"
        >
          {text.expenseDate
            ? moment(text.expenseDate).format("DD-MM-YYYY")
            : ""}
        </p>
      ),
      width: 110,
    },
    {
      key: "expenseNo",
      title: (
        <p className="header-purchase-invoice font-semibold">Expense No</p>
      ),
      dataIndex: "expenseNo",
      render: (record, text, row) => (
        <p
          onClick={() => expenseRoutes(text)}
          className="header-purchase-invoice"
        >
          {text.expenseNo}
        </p>
      ),
      width: 140,
    },
    {
      key: "isexpenseWithGST",
      title: (
        <p className="header-purchase-invoice font-semibold">
          Expense With GST
        </p>
      ),
      dataIndex: "isexpenseWithGST",
      render: (record, text, row) => (
        <Badge
          className={
            text.isexpenseWithGST &&
            text.isexpenseWithGST &&
            text.isexpenseWithGST === true
              ? "bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-2"
              : "bg-[#f1e7e9] font-semibold header-sales-invoice rounded-md text-[#d01717] text-[12px] p-2"
          }
          onClick={() => expenseRoutes(text)}
        >
          {text.isexpenseWithGST && text.isexpenseWithGST === true
            ? "YES"
            : "NO"}
        </Badge>
      ),
      width: 150,
    },
    {
      key: "partyName",
      title: (
        <p className="header-purchase-invoice font-semibold">Party Name</p>
      ),
      dataIndex: "partyName",
      render: (record, text, row) => (
        <p
          className="header-purchase-invoice"
          onClick={() => expenseRoutes(text)}
        >
          {text.partyName ? text.partyName : "--"}
        </p>
      ),
      width: 130,
    },
    {
      key: "categoryName",
      title: <p className="header-purchase-invoice font-semibold">Category</p>,
      dataIndex: "categoryName",
      render: (record, text, row) => (
        <p
          className="header-purchase-invoice"
          onClick={() => expenseRoutes(text)}
        >
          {text.categoryName}
        </p>
      ),
      width: 140,
    },
    {
      key: "paymentModeName",
      title: (
        <p className="header-purchase-invoice font-semibold">Payment Mode</p>
      ),
      dataIndex: "paymentModeName",
      render: (record, text, row) => (
        <p
          className="header-purchase-invoice"
          onClick={() => expenseRoutes(text)}
        >
          {text.paymentModeName}
        </p>
      ),
      width: 140,
    },
    {
      key: "totalAmount",
      title: <p className="header-purchase-invoice font-semibold">Amount</p>,
      dataIndex: "totalAmount",
      render: (record, text, row) => (
        <div className="flex" onClick={() => expenseRoutes(text)}>
          <p>{"₹ "}</p>
          <p className="header-purchase-invoice cursor-pointer ml-1">
            {text.totalAmount && text.totalAmount.toLocaleString("en-IN")}
          </p>
        </div>
      ),
      width: 130,
    },
    {
      key: "status",
      title: <p className="header-purchase-invoice font-semibold">Status</p>,
      dataIndex: "status",
      render: (record, text, row) => (
        <Badge
          className={
            text.status && text.status && text.status.statusName === "Active"
              ? "bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-2"
              : "bg-[#f1e7e9] font-semibold header-sales-invoice rounded-md text-[#d01717] text-[12px] p-2"
          }
          onClick={() => expenseRoutes(text)}
        >
          {text.status && text.status && text.status.statusName}
        </Badge>
      ),
      width: 130,
    },
  ];

  //row and data table section

  // const [itemCategory, setItemCategory] = useState([]);

  const [expensesRows, setExpensesRows] = useState([
    {
      accountName: "",
      accountId: "",
      partyId: "",
      additionalCharges: "",
      additionalAmount: "",
      categoryId: "",
      categoryName: "",
      createdBy: "",
      expenseDate: "",
      expenseItem: [],
      expenseNo: "",
      isexpenseWithGST: "",
      itemsTotalAmount: "",
      itemsTotalDiscount: "",
      itemsTotalTax: "",
      notes: "",
      orginalInvoiceNo: "",
      partyName: "",
      paymentModeId: "",
      paymentModeName: "",
      totalAmount: "",
      discountAmount: "",
      totalAmount: "",
      transActionType: "",
      _id: "",
      status: "",
      updatedAt: "",
    },
  ]);

  const [search, setSearch] = useState("");

  //Expenses table filter based on tab selection

  const expensesDataTable =
    expenses_list && expenses_list.length > 0
      ? expenses_list.map((data, index) => {
          return {
            index: index + 1,
            accountName: data.accountName,
            partyId: data.partyId,
            accountId: data.accountId,
            additionalCharges: data.additionalCharges,
            additionalAmount:
              data.additionalCharges && data.additionalCharges.length > 0
                ? data.additionalCharges[0].chargeAmount
                : 0,
            discountAmount: data.discountAmount,
            categoryId: data.categoryId,
            categoryName: data.categoryName,
            createdBy: data.createdBy,
            expenseDate: data.expenseDate,
            expenseItem: data.expenseItem,
            expenseNo: data.prefixName
              ? data.prefixName + " " + data.expenseNo
              : data.expenseNo,
            accountDetails: data.accountDetails,
            isexpenseWithGST: data.isexpenseWithGST,
            itemsTotalAmount: data.itemsTotalAmount,
            itemsTotalDiscount: data.itemsTotalDiscount,
            itemsTotalTax: data.itemsTotalTax,
            notes: data.notes,
            orginalInvoiceNo: data.orginalInvoiceNo,
            partyName: data.partyName ? data.partyName : "",
            paymentModeId: data.paymentModeId,
            paymentModeName: data.paymentModeName,
            totalAmount: data.totalAmount,
            transActionType: data.transActionType,
            _id: data._id,
            status: data.status.length > 0 && data.status[0],
            updatedAt: data.updatedAt,
          };
        })
      : [];

  useEffect(() => {
    if (expensesDataTable && expensesDataTable.length > 0) {
      setExpensesRows(expensesDataTable);
    } else if (expensesDataTable && expensesDataTable.length == 0) {
      setExpensesRows([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expenses_list, dateFilter]);

  //expand row
  const expandColumns = [
    {
      title: (
        <p className="header-expand-purchase-invoice">Expense Item Name</p>
      ),
      dataIndex: "expenseItemName",
      key: "expenseItemName",
    },
    {
      title: <p className="header-expand-purchase-invoice">Price</p>,
      dataIndex: "priceofItem",
      key: "priceofItem",
      render: (record, text, row) => (
        <div className="flex">
          <p>{"₹ "}</p>
          <h1 className="cursor-pointer ml-1 mt-[2px] header-sales-invoice">
            {text.priceofItem && text.priceofItem.toLocaleString("en-IN")}
          </h1>
        </div>
      ),
    },
    {
      title: <p className="header-expand-purchase-invoice">Qty</p>,
      key: "qty",
      dataIndex: "qty",
    },
    {
      title: <p className="header-expand-purchase-invoice">Taxable Amount</p>,
      dataIndex: "taxableAmount",
      key: "taxableAmount",
      render: (record, text, row) => (
        <div className="flex">
          <p>{"₹ "}</p>
          <h1 className="cursor-pointer ml-1 mt-[2px] header-sales-invoice">
            {text.taxableAmount && text.taxableAmount.toLocaleString("en-IN")}
          </h1>
        </div>
      ),
    },
    {
      title: <p className="header-expand-purchase-invoice">Discount Amount</p>,
      key: "discountAmount",
      dataIndex: "discountAmount",
      render: (record, text, row) => (
        <div className="flex">
          <p>{"₹ "}</p>
          <h1 className="cursor-pointer ml-1 mt-[2px] header-sales-invoice">
            {text.discountAmount && text.discountAmount.toLocaleString("en-IN")}
          </h1>
        </div>
      ),
    },
    {
      title: <p className="header-expand-purchase-invoice">Total Amount</p>,
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (record, text, row) => (
        <div className="flex">
          <p>{"₹ "}</p>
          <h1 className="cursor-pointer ml-1 mt-[2px] header-sales-invoice">
            {text.totalAmount && text.totalAmount.toLocaleString("en-IN")}
          </h1>
        </div>
      ),
    },
  ];

  // expand row
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const onTableRowExpand = (expanded, record) => {
    console.log(record, "record");
    const keys = [];
    if (expanded) {
      keys.push(record._id); // I have set my record.id as row key. Check the documentation for more details.
    }

    setExpandedRowKeys(keys);
  };

  const expandedRowRender = (row) => {
    // console.log(row, "row");
    const expandRowData =
      row && row.expenseItem.length > 0
        ? row.expenseItem.map((data) => {
            const taxableTotalAmount =
              data.priceofItem && data.taxableAmount
                ? parseInt(data.priceofItem + data.taxableAmount)
                : data.priceofItem;
            const totalAmount =
              data.qty * (taxableTotalAmount - data.discountAmount);
            return {
              discountAmount: data.discountAmount,
              discountPercentage: data.discountPercentage + "% ",
              expenseItemName: data.expenseItemName,
              gstrateName: data.gstrateName,
              hsnCode: data.hsnCode,
              itcName: data.itcName,
              priceofItem: data.priceofItem,
              qty: data.qty,
              taxableAmount: data.taxableAmount,
              totalAmount: totalAmount,
              taxablePercentage: data.taxablePercentage + "% ",
              _id: data.expenseitemId,
            };
          })
        : [];
    return (
      <Table
        columns={expandColumns}
        dataSource={expandRowData}
        pagination={false}
        rowClassName={""}
      />
    );
  };
  //table search
  const handleSearch = (event) => {
    const filteredRows = expensesDataTable
      .filter((row) =>
        row.expenseNo.toLowerCase().includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setExpensesRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //category api integrations
  // const createCategory = () => {
  //   if (simpleValidator.current.allValid()) {
  //     const categoryList = {
  //       categoryName: categoryName,
  //       organizationId: organizationId,
  //       shortCode: shortCode,
  //       description: description,
  //       createdBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
  //     };

  //     dispatch(createExpensesCategoryList(categoryList));
  //     setTimeout(() => {
  //       dispatch(loadExpensesListCategory(orgList));
  //       setItemCategoryModal(false);
  //       toast.success("Category created successfully");
  //     }, 1000);
  //   } else {
  //     simpleValidator.current.showMessages();
  //     forceUpdate(1);
  //   }
  // };

  const addCategoryApi = () => {
    if (!isEmpty(expenseData.expenseName)) {
      const categoryDetails = {
        organizationId: organizationId,
        expenseName: expenseData.expenseName,
        createdBy: userId,
      };

      api
        .post("/org/addexpensecategory", categoryDetails)
        .then((res) => {
          toast.success("Expense categories added successfully");
          setNewExpenseCategory(false);
          dispatch(
            loadExpensesCategories({
              organizationId: organizationId,
            })
          );
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message;
          toast.error(errorMsg || "An Error while adding the expense category");
          return Promise.reject(error);
        });
    } else {
      toast.error("The expense name field is required");
    }
  };

  const updateCategoryApi = () => {
    if (!isEmpty(expenseData.expenseName)) {
      const categoryDetails = {
        organizationId: organizationId,
        expenseName: expenseData.expenseName,
        updatedBy: userId,
        expensecategoryId: expenseData._id,
      };

      api
        .put("/org/editexpensecategory", categoryDetails)
        .then((res) => {
          toast.success("Expense categories updated successfully");
          setNewExpenseCategory(false);
          dispatch(
            loadExpensesCategories({
              organizationId: organizationId,
            })
          );
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message;
          toast.error(
            errorMsg || "An Error while updating the expense caegory"
          );
          return Promise.reject(error);
        });
    } else {
      toast.error("The expense name field is required");
    }
  };

  const deleteCategoryApi = () => {
    const categoryDetails = {
      organizationId: organizationId,
      expenseName: expenseData.expenseName,
      deletedBy: userId,
      expensecategoryId: expenseData._id,
    };

    api
      .post("/org/deleteexpensecategory", categoryDetails)
      .then((res) => {
        toast.info("Expense categories deleted successfully");
        setDeleteCategory(false);
        dispatch(
          loadExpensesCategories({
            organizationId: organizationId,
          })
        );
        return res.data;
      })
      .catch((error) => {
        const errorMsg =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message;
        toast.error(errorMsg || "An Error while deleting the expense caegory");
        return Promise.reject(error);
      });
  };

  useBeforeUnload({
    when: !isEmpty(categories),
    message: "Are you sure you want to leave?",
  });

  //window height/width

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Expenses | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid pb-[220px] rounded-sm bg-[#ffffff]">
        {/* <Skeleton.Input
          style={{
            padding: "5px",
            width: "100%",
          }}
          active={true}
          size={"large"}
        > */}
        <Col span={24} className="border border-b-1 border-t-0 border-x-0 pb-2">
          <div
            className={
              media == "xs"
                ? "font-poppins flex flex-col pl-[20px] pr-[20px] mt-4"
                : "font-poppins flex justify-between pl-[20px] pr-[20px] mt-4"
            }
          >
            <div className="flex">
              <ArrowLeftOutlined
                onClick={() => setPageRouting(true)}
                className="font-bold text-[18px]"
              />
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[18px] ml-2 mt-1 font-semibold"
              >
                Expenses
              </h1>
            </div>
            <div className={media == "xs" ? "flex mt-2" : "flex"}>
              <Dropdown
                menu={{
                  items,
                }}
                trigger={["click"]}
                className="text-[#0c8ce9] rounded-md"
              >
                <Tooltip
                  title="See all your purchase specific reports"
                  placement="left"
                  rootClassName="text-[10px]"
                >
                  <div
                    style={{
                      border: "1px solid #9ed1f6",
                    }}
                    className="border flex justify-between w-[180px] pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                  >
                    <div>
                      <FileTextOutlined /> Reports
                    </div>
                    <DownOutlined />
                  </div>
                </Tooltip>

                {/* </a> */}
              </Dropdown>
              {/* <Tooltip
                title="Easily add the purchase invoice settings"
                placement="bottom"
                rootClassName="text-[10px]"
              >
                <div
                  onClick={() => setSettingsFieldModal(true)}
                  className="border rounded-md ml-3 p-2.5 cursor-pointer"
                >
                  <SettingOutlined />
                </div>
              </Tooltip> */}
            </div>
          </div>
        </Col>
        {/* </Skeleton.Input> */}
        <div
          className={
            media === "sm" || media === "xs"
              ? ""
              : // : windowDimensions.height > 600 && windowDimensions.height < 650
              // ? "cash-bank-details-card-mobile"
              // : windowDimensions.height > 650 && windowDimensions.height < 700
              // ? "expenses-home-card-medium"
              // : windowDimensions.height > 700 && windowDimensions.height < 830
              // ? "expenses-home-card-large-device mt-3"
              // : windowDimensions.height > 830 && windowDimensions.height < 900
              // ? "expenses-home-card-extra-large-device mt-3"
              // : windowDimensions.height > 900 && windowDimensions.height < 1000
              // ? "expenses-home-card-extra-extra-large-device mt-3"
              windowDimensions.height >= 1000
              ? "expenses-home-card-extra-infinite-device mt-3"
              : "expenses-home-card-small mt-3"
          }
          style={{
            fontFamily: "Poppins",
          }}
        >
          {/* Expenses input section with bulk actions */}
          <Col span={24}>
            <Row
              className={
                loading
                  ? "flex justify-between mt-5 ml-4 pr-8"
                  : media == "sm" || media == "xs"
                  ? "flex flex-col mt-5 ml-4"
                  : "flex justify-between mt-5 ml-4"
              }
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    marginRight: "5px",
                    width: "100%",
                    height: "40px",
                  }}
                  active={true}
                  size={"large"}
                  // block={true}
                ></Skeleton.Input>
              ) : (
                <div
                  className={
                    media == "sm" || media == "xs" ? "flex flex-col" : "flex"
                  }
                >
                  <Tooltip
                    rootClassName="text-[10px]"
                    title="Search by expense"
                    placement="bottom"
                  >
                    <AutoComplete
                      className={
                        media == "sm"
                          ? "w-[366px] h-[40px] mb-2"
                          : media == "xs"
                          ? "w-[230px] h-[40px] mb-2"
                          : media == "xxl" || media == "xl"
                          ? "w-[180px] h-[40px]"
                          : "w-[160px] h-[40px]"
                      }
                      style={{
                        marginRight: "12px",
                        fontFamily: "Poppins",
                      }}
                    >
                      <Input.Search
                        size="large"
                        placeholder="Search Expense"
                        style={{
                          fontFamily: "Poppins",
                        }}
                        name="search"
                        value={search}
                        onChange={(e) => handleSearch(e)}
                      />
                    </AutoComplete>
                  </Tooltip>
                  <div>
                    <RangePicker
                      // style={{
                      //   width: 180,
                      //   height: 40,
                      // }}
                      // value={selectDays}
                      onChange={(date, dateString) => {
                        console.log(date, "date");

                        // setSelectDays(dateString);
                        setDateFilter(true);
                        if (dateString) {
                          const startMonth =
                            dateString &&
                            dateString.length > 0 &&
                            dateString[0];

                          const endMonth =
                            dateString &&
                            dateString.length > 0 &&
                            dateString[1];

                          const ledgerStatementData = {
                            organizationId: organizationId,
                            fromDate:
                              startMonth &&
                              moment(startMonth).format("YYYY-MM-DD"),
                            toDate:
                              endMonth && moment(endMonth).format("YYYY-MM-DD"),
                          };
                          console.log(startMonth, "startMonth");
                          console.log(endMonth, "endMonth");
                          // setLedgerData({
                          //   ...ledgerData,
                          //   startMonth: startMonth,
                          //   endMonth: endMonth,
                          // });
                          dispatch(loadExpensesList(ledgerStatementData));
                        }
                      }}
                      suffixIcon={<BiCalendar size={18} />}
                      allowClear
                      onClear={() => setSelectDays([])}
                      className={
                        media == "sm"
                          ? "w-[366px] h-[40px] mb-2"
                          : media == "xs"
                          ? "w-[230px] h-[40px] mb-2"
                          : media == "xxl" ||
                            media == "xl" ||
                            media == "lg" ||
                            media == "md"
                          ? "w-[180px] h-[40px]"
                          : "w-[100%] h-[40px]"
                      }
                      placeholder="Select Days"
                      options={[]}
                    />
                  </div>
                  <div>
                    <Select
                      className={
                        media == "sm"
                          ? "w-[366px] h-[40px] mb-2"
                          : media == "xs"
                          ? "w-[230px] h-[40px] mb-2"
                          : media == "xxl" || media == "xl"
                          ? "w-[240px] h-[40px] ml-3"
                          : "w-[220px] h-[40px] ml-3"
                      }
                      value={categories}
                      allowClear
                      onClear={() => {
                        setCategories([]);
                        console.log("cleared");
                      }}
                      onChange={(e) => {
                        if (!isEmpty(e)) {
                          setCategories(e);
                          const filteredRows = expensesDataTable.filter(
                            (data) => data.categoryId === e
                          );
                          console.log(expensesRows, "expensesRows");
                          console.log(filteredRows, "filteredRows");
                          setTableLoading(true);
                          setExpensesRows(filteredRows);
                          setTimeout(() => {
                            setTableLoading(false);
                          }, 1000);
                        } else {
                          setExpensesRows(expensesDataTable);
                        }
                        // else {
                        //   setExpensesRows(expensesRows);

                        // }
                      }}
                      placeholder="Select Categories"
                      dropdownRender={(menu) => (
                        <div>
                          <p
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "11px",
                            }}
                          >
                            {menu}
                          </p>
                          <Divider
                            style={{
                              margin: "8px 0",
                            }}
                          />
                          <div
                            className={
                              media == "md"
                                ? "pl-2 pr-2 mt-1 text-[11px]"
                                : "pl-2 pr-2 mt-1"
                            }
                          >
                            <Button
                              type="dashed"
                              icon={<PlusOutlined />}
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "12px",
                              }}
                              onClick={() => setAddCategoryModal(true)}
                              className="w-[100%] text-blue-500 border border-2 mt-1 mb-1 border-blue-300"
                            >
                              Add / Manage Category
                            </Button>
                          </div>
                        </div>
                      )}
                      options={categoryOptions}
                    />
                  </div>
                </div>
              )}
              <div className={"flex"}>
                {loading ? (
                  <Skeleton.Input
                    style={{
                      marginLeft: "15px",
                      width: "100%",
                      height: "40px",
                    }}
                    active={true}
                    size={"large"}
                    // block={true}
                  ></Skeleton.Input>
                ) : (
                  <Button
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className={
                      media == "md"
                        ? "ml-1 mt-2 bg-[blueviolet] p-5 text-[white] mr-3"
                        : "ml-3 bg-[blueviolet] p-5 text-[white] mr-3"
                    }
                  >
                    <Link
                      to={{
                        pathname: "/create-expenses",
                        state: {
                          organizationId: organizationId,
                          userId: userId,
                          orgList: orgList,
                          categoryOptions: categoryOptions,
                        },
                      }}
                    >
                      Create Expenses
                    </Link>
                  </Button>
                )}
              </div>
            </Row>
          </Col>
          <Col span={24} className="pt-3 pb-3 pr-4 pl-4">
            <Table
              style={{
                // overflow: "hidden",
                cursor: "pointer",
              }}
              bordered
              columns={HeaderData}
              dataSource={
                expensesRows &&
                expensesRows.length > 0 &&
                !isEmpty(expensesRows[0]._id)
                  ? expensesRows
                  : []
              }
              expandable={{
                expandedRowRender: expandedRowRender,
                defaultExpandAllRows: false,
                expandedRowKeys: expandedRowKeys,
                onExpand: onTableRowExpand,
              }}
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "20", "30"],
              }}
              sortDirections={"ascend"}
              // onHeaderRow={}
              loading={tableLoading ? true : false}
              rowKey={(record) => record._id}
              scroll={{
                y:
                  windowDimensions.height >= 500 &&
                  windowDimensions.height <= 700
                    ? "100%"
                    : windowDimensions.height > 700 &&
                      windowDimensions.height <= 1000
                    ? "100%"
                    : windowDimensions.height > 1000
                    ? "100%"
                    : 250,
                x: 765,
              }}
              showSorterTooltip={"sorter-icon"}
            />
          </Col>
        </div>

        <Modal
          open={pageRouting}
          onOk={() => {
            setPageRouting(false);
            history.push("/dashboard");
          }}
          closeIcon
          maskClosable={false}
          rootClassName="p-15 h-[300px]"
          okText={"Yes, Leave"}
          cancelText={"No, Stay"}
          onCancel={() => setPageRouting(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <div className="mr-3">
                <OkBtn />
              </div>
              <CancelBtn />
            </div>
          )}
          width={500}
        >
          <div className="text-center w-[100%]">
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="text-center text-[18px] font-bold">
              Are you sure you want to leave this page?
            </h1>
            <p className="text-center text-[14px] mt-2">
              All unsaved changes will be lost!
            </p>
          </div>
        </Modal>
      </Row>
      <Prompt
        when={!isEmpty(categories)}
        message="Are you sure you want to leave?"
      />
      {/* Category modal */}
      <Modal
        open={addCategoryModal}
        title="Add / Manage Category"
        onOk={() => setAddCategoryModal(false)}
        closeIcon
        maskClosable={false}
        okText={"Save"}
        width={600}
        className="mt-[-70px]"
        onCancel={() => setAddCategoryModal(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div
            style={{
              display: "none",
            }}
          >
            <CancelBtn />
            <OkBtn />
          </div>
        )}
      >
        <Divider
          style={{ borderWidth: "0.2px", width: "108%", marginLeft: "-24px" }}
        />
        <Col span={24} className="mt-5">
          {categoryOptions.map((data, index) => {
            return (
              <div key={index}>
                <div className="mb-2 mt-6 flex justify-between">
                  <h1
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "12px",
                    }}
                  >
                    {data.label}
                  </h1>
                  <div className="flex">
                    <div
                      onClick={() => {
                        setNewExpenseCategory(true);
                        setNewExpenseMode("Edit");
                        setExpenseData({
                          ...expenseData,
                          expenseName: data.label,
                          _id: data.value,
                        });
                      }}
                      className="text-[12px] flex border mb-2 rounded-md p-2 cursor-pointer"
                    >
                      <EditOutlined className="text-[16px] mr-2" />
                      Edit
                    </div>
                    <div
                      onClick={() => {
                        setDeleteCategory(true);
                        setExpenseData({
                          ...expenseData,
                          _id: data.value,
                        });
                      }}
                      className="text-[12px] ml-2 border mb-2 rounded-md p-2 cursor-pointer"
                    >
                      <DeleteOutlined className="text-[16px] text-[#dc3545]" />
                    </div>
                  </div>
                </div>
                <Divider
                  style={{
                    width: "109%",
                    marginTop: "-5px",
                    marginBottom: "-5px",
                    marginLeft: "-24px",
                  }}
                />
              </div>
            );
          })}
        </Col>
        <Col span={24} className="mt-5">
          <div
            onClick={() => {
              setNewExpenseCategory(true);
              setNewExpenseMode("Add");
              setExpenseData({
                _id: "",
                expenseName: "",
              });
            }}
            style={{
              fontFamily: "Poppins",
            }}
            className="cursor-pointer w-[100%] rounded-md text-center p-2 border border-dashed border-blue-400 border-2 text-blue-400  mb-2"
          >
            + New Expense Category
          </div>
        </Col>
      </Modal>

      {/* New Expense modal */}
      <Modal
        open={newExpenseCategory}
        title={
          newExpenseMode === "Edit"
            ? `Edit ${expenseData.expenseName}`
            : "Create New Category"
        }
        onOk={newExpenseMode === "Edit" ? updateCategoryApi : addCategoryApi}
        closeIcon
        maskClosable={false}
        okText={"Save"}
        width={450}
        onCancel={() => setNewExpenseCategory(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        )}
      >
        <Divider
          style={{
            borderWidth: "0.2px",
            marginTop: "3px",
            width: "112%",
            marginLeft: "-24px",
          }}
        />
        <Col span={24} className="mb-[50px]">
          <Typography
            className="uppercase mb-1"
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
            }}
          >
            Category Name
          </Typography>
          <Input
            name="expenseName"
            value={expenseData.expenseName}
            onChange={(e) => handleChange(e)}
            placeholder="Enter Category Name"
            className="p-2"
          />
        </Col>
      </Modal>

      <Modal
        open={deleteCategory}
        onOk={() => deleteCategoryApi()}
        closeIcon
        maskClosable={false}
        rootClassName="p-15 h-[300px]"
        okText={"Yes, Delete"}
        cancelText={"Cancel"}
        okType="danger"
        onCancel={() => setDeleteCategory(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <CancelBtn />
            <div className="ml-2">
              <OkBtn />
            </div>
          </div>
        )}
        width={450}
      >
        <div className="text-center p-3 w-[100%]">
          <DeleteOutlined className="mb-2 text-center text-[#dc3545] font-bold text-[44px]" />
          <h1
            style={{
              fontFamily: "Poppins",
            }}
            className="text-center text-[18px] font-bold"
          >
            Delete Expense Category?
          </h1>
          <p
            style={{
              fontFamily: "Poppins",
            }}
            className="text-center text-[14px] text-[#8b8b8b] mt-2"
          >
            Are you sure you want to delete this expense category? Deleted
            category cannot be retrieved
          </p>
        </div>
      </Modal>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        // pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{
          fontSize: "12px",
          fontFamily: "Poppins",
        }}
      />
    </React.Fragment>
  );
};

Expenses.propTypes = {
  location: PropTypes.any,
};

export default Expenses;
